export default "__VITE_ASSET__uwof5g7___"